
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AnalysisIssueUnion": [
      "StaticAnalysisIssue",
      "AIReviewIssue"
    ],
    "MaskPrimaryKeyNode": [
      "AccessToken",
      "AgentsProduct",
      "AnalysisMemory",
      "Analyzer",
      "AnalyzerCISnippet",
      "AnalyzerReview",
      "AnalyzerSyncJob",
      "AuditLog",
      "AutoOnboardEvent",
      "AutofixRun",
      "BilledRepositoryTarget",
      "CallStackFrame",
      "Check",
      "CheckIssue",
      "CheckPackage",
      "CodeQualityProduct",
      "ConfigGenerationRun",
      "ConfigTemplate",
      "EnterpriseBilledRepositoryTarget",
      "EnterpriseGroup",
      "EnterpriseInstallationSetup",
      "EnterpriseTeam",
      "EnterpriseUser",
      "FeatureDefinition",
      "GroupTeamMembership",
      "GroupUserMembership",
      "IDEProduct",
      "IdentityProvider",
      "Issue",
      "IssueDispositionType",
      "IssuePriority",
      "IssuePriorityType",
      "License",
      "Metric",
      "Owner",
      "OwnerAIPolicy",
      "OwnerDynamicRiskConfig",
      "OwnerLicensePolicy",
      "OwnerProfile",
      "OwnerSCAPolicy",
      "OwnerSetting",
      "PR",
      "PRAuthor",
      "Package",
      "PackageUpgradeSummary",
      "PackageVersion",
      "ProductSubscription",
      "PublicReport",
      "Repository",
      "RepositoryCollaborator",
      "RepositoryComplianceReportItem",
      "RepositoryCoverageReportItem",
      "RepositoryGroup",
      "RepositoryGroupSetting",
      "RepositoryIssue",
      "RepositoryMetricValue",
      "RepositoryPackage",
      "RepositoryScaTargetReportItem",
      "RepositorySetting",
      "RepositoryTarget",
      "Run",
      "RunReport",
      "Runner",
      "RunnerApp",
      "RuntimeLog",
      "SCACheck",
      "SCAProduct",
      "SSOIdentityProvider",
      "SilenceRule",
      "SourceableRepository",
      "Team",
      "TeamBasePermissionSet",
      "TeamMember",
      "TeamMemberAdditionRequest",
      "TeamMemberInvitation",
      "TransformerReview",
      "TransformerRun",
      "TransformerTool",
      "UnifiedProduct",
      "User",
      "UserPreference",
      "UserProfile",
      "UserSocialConnection",
      "VerifiableDomain",
      "Vulnerability",
      "VulnerabilityCallStack",
      "VulnerabilityOccurrence",
      "VulnerabilityRemediationFixPath",
      "VulnerabilityRemediationFixPathUpdate",
      "VulnerabilityRemediationPatchRun",
      "Webhook",
      "WebhookEventDelivery",
      "WebhookEventTypes"
    ],
    "Product": [
      "AgentsProduct",
      "CodeQualityProduct",
      "IDEProduct",
      "SCAProduct",
      "UnifiedProduct"
    ],
    "SubscriptionSponsor": [
      "Owner"
    ]
  }
};
      export default result;
    